import { render, staticRenderFns } from "./LeftPanelNavDrawer.vue?vue&type=template&id=97b40412&"
import script from "./LeftPanelNavDrawer.vue?vue&type=script&lang=js&"
export * from "./LeftPanelNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports